import {
  Autocomplete,
  FormControl,
  FormLabel,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

const PincodeSelect = ({
  label = "Pincode",
  value,
  onBlur = () => {},
  onChange = () => {},
  error,
}) => {
  const { Common, Translation } = useSelector((state) => ({
    Common: state.Common.common,
    Translation: state.Translation.translation?.Common || {},
  }));

  const city = Common?.City || [];

  const selectedOption = React.useMemo(() => {
    return city.find((item) => item.Pincode == value) || null;
  }, [city, value]);

  return (
    <FormControl fullWidth>
      <FormLabel color="secondary" required label>
        {/* {label} */}
        {Translation?.Pincode}
      </FormLabel>
      <Autocomplete
        options={city}
        autoHighlight
        getOptionLabel={(option) => option.Pincode}
        clearIcon={false}
        value={selectedOption}
        onBlur={onBlur}
        onChange={(value, newVal) => onChange(newVal)}
        noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <Typography key={key} {...optionProps}>
              {option?.PincodeValue}
            </Typography>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            error={Boolean(error)}
            name="Pincode"
            placeholder={Translation?.EnterYourPincode}
            helperText={error}
            slotProps={{
              htmlInput: {
                ...params.inputProps,
                autoComplete: "new-password",
              },
            }}
          />
        )}
      />
    </FormControl>
  );
};

export default React.memo(PincodeSelect);
